import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "@/plugins/vuetify";
import VueFullScreen from "@/plugins/VueFullScreen";
import vueEditor from "@/plugins/vueEditor";
import vue2Dropzone from "@/plugins/vue2Dropzone";
import i18n from "@/plugins/i18n";
import VueCryptojs from "@/plugins/cryptojs";
import VueLazyload from "@/plugins/lazyload";
import "@/plugins/apexcharts";
import otp from "./plugins/otp";
import draggable from "@/plugins/vuedraggable";
import VueExcelEditor from "@/plugins/VueExcelEditor";
import apiPlugin from "@/plugins/api";
import global from "@/plugins/global";
import "./registerServiceWorker";
import VueSweetalert2 from "@/plugins/sweetalert";
import filters from "./filters/filters";
Vue.use(global);
Vue.use(apiPlugin);
Vue.filter(filters);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  VueFullScreen,
  vueEditor,
  vue2Dropzone,
  i18n,
  VueCryptojs,
  VueLazyload,
  draggable,
  VueSweetalert2,
  otp,
  VueExcelEditor,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
